import { Box, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';

import RowWrap from '../common/IntakeRowWrap';

function IntakeAccreditedCheck({
  isCollege,
  onChange,
}: {
  isCollege: boolean | null;
  onChange: (isCollege: boolean | null) => void;
}) {
  const [college, setCollege] = useState<boolean | null>(isCollege);

  const handleIsCollegeChange = (newIsCollegeValue: boolean | null) => {
    onChange(newIsCollegeValue);
  };

  useEffect(() => {
    if (isCollege !== college) {
      setCollege(isCollege);
    }
  }, [isCollege, college]);

  return (
    <RowWrap>
      <Box width='100%'>
        <SelectInput
          value={college == null ? '' : college === true ? 'yes' : 'no'}
          id='college-select'
          label={'Are you a 2- or 4-year accredited college or university?'}
          selectOptions={[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ]}
          onChange={(e: SelectChangeEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const booleanValue =
              e.target.value === 'yes' ? true : e.target.value === 'no' ? false : null;

            handleIsCollegeChange(booleanValue);
          }}
        />
      </Box>
    </RowWrap>
  );
}

export default IntakeAccreditedCheck;
